module.exports = __webpack_public_path__ + "gm.814fdc51.svg";